import { Link } from "react-router-dom";
import { useTheme } from "@/context/ThemeContext";

export default function HomeCTASection() {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <section className="relative py-36 md:py-52 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/48bdc786ad33da2364bfeadc0b6b61ba.jpg"
          alt="CTA background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-10 text-center">
        <p className="text-white/40 text-[11px] tracking-[0.15em] uppercase font-semibold mb-10">Ready to Scale?</p>
        <h2 className="text-5xl md:text-7xl lg:text-8xl font-black text-white leading-[1.0] tracking-[-0.03em] mb-4">
          Stop losing leads.
        </h2>
        <h2 className="text-5xl md:text-7xl lg:text-8xl font-black text-white/30 leading-[1.0] tracking-[-0.03em] mb-14">
          Start operating like a system.
        </h2>
        <Link
          to="/contact"
          className="inline-block px-10 py-5 bg-white text-[#0a0a0a] text-base font-bold rounded-full hover:bg-white/92 transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105"
        >
          Book Your AI Strategy Call
        </Link>
        <p className="mt-6 text-white/30 text-sm font-light">No commitment. Just clarity on where your revenue is leaking.</p>
      </div>
    </section>
  );
}
